<template>
    <modal ref="modal" size="lg">
        <div class="d-block text-center" slot="title">
            Delete Scheduled Invites
        </div>

        <div class="alert alert-warning">
            Are you sure you want to delete all invite(s) selected?
        </div>

        <v-client-table ref="table"
                        :data="bulkInvites"
                        :columns="['name', 'phone', 'email']"
                        :options="options"
        />

        <span slot="footer">
            <button type="button" class="btn btn-default" @click="closeModal()">Cancel</button>
            <button type="button" class="btn btn-primary" @click="deleteInvite()">Yes</button>
        </span>
    </modal>
</template>

<script>
    import ModalComponent from '../../mixins/ModalComponent';

    export default {
        mixins: [ModalComponent],

        props: {
            invites: {
                type    : Array,
                required: true
            }
        },

        data() {
            return {
                options    : {
                    sortable: ['name']
                },
                bulkInvites: []
            }
        },

        watch: {
            invites() {
                this.bulkInvites = [];
                this.invites.map((invite) => {
                    this.bulkInvites.push({
                        name : invite.contact.name,
                        phone: invite.contact.phone_number,
                        email: invite.contact.email
                    })
                })
            }
        },

        methods: {
            afterOpen() {
                $('#delete-scheduled-invite').tooltip('hide');
            },

            deleteInvite() {
                const url = this.$laroute.route('api.invites.destroy-scheduled-invites', {
                    invites: this.invites.map(invite => invite.id)
                });

                this.$http.delete(url)
                    .then(() => {
                        this.$refs.modal.close();
                        this.$alert({
                            message: 'Invites deleted.',
                            type   : 'success',
                            title  : 'Success!'
                        });
                        this.bulkInvites               = [];
                        this.$parent.selectedInvites   = [];
                        this.$parent.selectedScheduled = [];
                        this.$parent.fetchInvites();
                    })
            },

            closeModal() {
                this.$refs.modal.close();
            },
        }
    }
</script>

